export default __webpack_public_path__ + "static/media/icon_guide_step.e8a4bef4.svg";